import { productEventSchema, type ProductEvent } from './events';
import { safeProductPropertiesSchema, type SafeProductProperties } from './properties';
import { ProductPropertiesError, sanitizeProductProperties } from './rich-properties';

export function assertSafeProductProperties(properties: unknown): SafeProductProperties {
  const parsed = safeProductPropertiesSchema.parse(properties);
  const sanitized = sanitizeProductProperties(parsed);
  if (sanitized.removedSecretCount > 0) {
    throw new ProductPropertiesError('Safe product properties must not contain credentials');
  }
  return safeProductPropertiesSchema.parse(sanitized.properties);
}

export function assertProductEvent(event: unknown): ProductEvent {
  const parsed = productEventSchema.parse(event);
  return productEventSchema.parse({
    ...parsed,
    properties: sanitizeProductProperties(parsed.properties).properties,
  });
}
